import { lazy, Suspense } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import Spinner from 'components/indicators/Spinner';
import NetworkChecker from 'components/network-checker';
import ErrorBoundary from 'utils/ErrorBoundary';
import Header from './header';
import './App.css';
import { MainContextProvider } from '../context/context';
import Footer from '../components/footer';

const Home = lazy(() => import('pages/home'));
const PoolPage = lazy(() => import('pages/pool'));
const PoolBasicPage = lazy(() => import('pages/pool-basic'));
const HowToPlay = lazy(() => import('pages/how-to-play'));
const AddPool = lazy(() => import('pages/add-pool'));

function App() {
  return (
    <>
      <HashRouter>
        <div className="app">
          <MainContextProvider>
            <Header className="app__header" />
            <NetworkChecker supportedChains={[1, 3, 333]} />
            <div className="app__body">
              <ErrorBoundary>
                <Suspense fallback={<Spinner />}>
                  <Switch>
                    <Route
                      path="/pool/most-basic"
                      render={() => <PoolBasicPage poolType="custom" poolKey="basic" />}
                      exact
                    />
                    <Route
                      path="/pool/basic/:poolIndex"
                      render={() => <PoolBasicPage poolType="basic" />}
                      exact
                    />
                    <Route path="/pool/resident/:poolIndex" component={PoolPage} />
                    <Route
                      path="/pool/itg-blue-lagoon"
                      render={() => <PoolBasicPage poolType="custom" poolKey="itg-blue-lagoon" />}
                    />
                    <Route path="/how-to-play" component={HowToPlay} exact />
                    <Route path="/add-pool" component={AddPool} exact />
                    <Route path="/" component={Home} />
                  </Switch>
                </Suspense>
              </ErrorBoundary>
            </div>
          </MainContextProvider>
        </div>
      </HashRouter>
      <Footer />
    </>
  );
}

export default App;
